/* Component Dependencies */
var bookedResHeaderTemplate = require('templates/bookedResHeader.hbs');
var bookedResHeaderUpcomingResTemplate = require('templates/bookedResHeader-upcomingRes.hbs');
var bookedResHeaderAssociateTemplate = require('templates/bookedResHeader-associate.hbs');
var bookedResHeaderAssociateModifyTemplate = require('templates/bookedResHeader-associateModify.hbs');
var bookedResHeaderUpcomingResAssociateTemplate = require('templates/bookedResHeader-upcomingResAssociate.hbs');
var bookedResHeaderChangeConfirmationTemplate = require('templates/bookedResHeader-changeConfirmation.hbs');
var Popup = require('libs/popup');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
    type: 'bookedResHeader',
    template: {
        'bookedResHeader': bookedResHeaderTemplate,
        'bookedResHeader-associate' : bookedResHeaderAssociateTemplate,
        'bookedResHeader-associateModify' : bookedResHeaderAssociateModifyTemplate,
        'bookedResHeader-upcomingResAssociate' : bookedResHeaderUpcomingResAssociateTemplate,
        'bookedResHeader-upcomingRes' : bookedResHeaderUpcomingResTemplate,
        'bookedResHeader-changeConfirmation': bookedResHeaderChangeConfirmationTemplate
    },
    bindEvents: function() {
        // Disable submit button on form submit
        this.$el.find('form').submit(function() {
            $(this).find('button[type="submit"]').attr('disabled', 'disabled');
        });

        this.registerPopup('.js-cancel-rooms.mi-popover');
    },
    registerPopup: function (selector) {
        if (this.$el.find(selector).length) {
            var popup = new Popup({
                selector: selector,
                sourceBlock: '.modal-content',
                alternateCloseMarkup: true
            });
            popup.register();
        }
    }
});
